function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomCornerRoomFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 5h2v24H3V5zM6 3h23v2H6V3zM3 5a2 2 0 012-2h1v2H3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11H11v12h12V11zM11 9a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V11a2 2 0 00-2-2H11z",
    fill: props.color
  }));
}

export default SvgIconRoomCornerRoomFilled;